import { common } from "@/services/common.request";
import { AxiosError } from "axios";
import { useMutation } from "react-query";

const useGuestFile = (setIsApiError?: (val: any) => void) => {
  const {
    data: uploadFileData,
    mutate: uploadFile,
    isLoading: isLoadingUploadFile,
    error,
  } = useMutation((params: Record<string, any>) => common.postUploadFile(params), {
    onSuccess: () => {
      if (setIsApiError) setIsApiError(null);
    },
    onError: (err: AxiosError) => {
      if (setIsApiError) setIsApiError(err.response?.data);
    },
  });

  return {
    uploadFileData,
    uploadFile,
    isLoadingUploadFile,
    error,
  };
};

export default useGuestFile;
